// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.device_status_enum */
var DeviceStatusEnum;
(function (DeviceStatusEnum) {
    DeviceStatusEnum["ONLINE"] = "ONLINE";
    DeviceStatusEnum["OFFLINE"] = "OFFLINE";
    DeviceStatusEnum["DECOMMISSIONED"] = "DECOMMISSIONED";
})(DeviceStatusEnum || (DeviceStatusEnum = {}));
;
export default DeviceStatusEnum;
/** Zod schema for device_status_enum */
export const deviceStatusEnum = z.nativeEnum(DeviceStatusEnum);
//# sourceMappingURL=DeviceStatusEnum.js.map